define(['jquery', 'jquery-validation'], ($) => {
  // / //////////////////////////////////////////////////////
  // /js/2011/satisfaction.js

  $.fn.preventDoubleSubmission = function preventDoubleSubmission() {
    $(this).on('submit', function submit(e) {
      const $form = $(this);

      if ($form.data('submitted') === true) {
        // Previously submitted - don't submit again
        e.preventDefault();
      } else {
        // Mark it so that the next submit can be ignored
        $form.data('submitted', true);
      }
    });

    // Keep chainability
    return this;
  };

  $(document).ready(() => {
    $('.rating').on('mouseover', '.smilie', (event) => {
      $(event.target).addClass('highlighted').prevAll().addClass('highlighted');
    }).on('mouseout', '.smilie', (event) => {
      const $delegateTarget = $(event.delegateTarget);
      const $target = $(event.target);

      const $checked = $delegateTarget.find('input:checked');
      $checked.next().nextAll().removeClass('highlighted');

      if ($checked.length === 0) {
        $target.removeClass('highlighted').prevAll().removeClass('highlighted');
      }
    }).on('change', 'input', (event) => {
      const $selected = $(event.target).next().addClass('highlighted');
      $selected.prevAll().addClass('highlighted');
      $selected.nextAll().removeClass('highlighted');
    });

    $('#satisfaction-form')
      .preventDoubleSubmission()
      .validate({
        ignore: '.ignore',
        rules: {
          ratingOverall: {
            required: true
          }
        },
        errorPlacement(error, element) {
          error.appendTo(element.parents('tr').find('td').first());
        }
      });
  });
});
